import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../../../layouts/common/ButtonFieldLayout';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

import s from './MatureContentField.scss';

const MatureContentField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const { field } = useController({
    name: ArtsAndCraftsDeviationFieldName.MATURE_CONTENT,
    control,
  });

  return (
    <ButtonFieldLayout
      label={t('artsAndCraftsDeviationPopup.form.matureContent.label')}
      labelClassName={s['label']}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
      subLabel={t('artsAndCraftsDeviationPopup.form.matureContent.subLabel')}
      subLabelClassName={s['sub-label']}
    >
      <div className={s['toggle-wrap']}>
        <MainToggle
          id={id}
          variant="main"
          size="medium"
          aria-labelledby={`${id}-label`}
          value={field.value}
          onChange={field.onChange}
        />
      </div>
    </ButtonFieldLayout>
  );
};
MatureContentField.displayName = 'MatureContentField';

export default MatureContentField;
